import React, { useState, useEffect } from 'react';
import FormDrawer from '../form-drawer';
import ContentLoading from '../ContentLoading';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




const ViewRoleModal = (props) => {
    const { isOpen, setIsOpen, title, data: permissionsData, rolePermissionLoading } = props;

    const [selectedPermissions, setSelectedPermissions] = useState(new Set())
    
    const initial = () => {
        const initialSelected = new Set();
        permissionsData?.forEach(permission => {
            // Check if all children have hasPermission set to true
            const allChildrenHavePermission = permission.companiesRolePermission.every(companyPermission => companyPermission.hasPermission);
            if (allChildrenHavePermission) {
                initialSelected.add(permission.parentPermission.id);
            }
            permission.companiesRolePermission.forEach(companyPermission => {
                if (companyPermission.hasPermission) {
                    initialSelected.add(companyPermission.companyPermission.id);
                }
            });
        });
        return initialSelected;
    }

    const handleCheckboxChange = (id, isParent = false, childPermissions = []) => {
        setSelectedPermissions((prevSelected) => {
            const newSelected = new Set(prevSelected);

            if (newSelected.has(id)) {
                newSelected.delete(id);
                if (isParent) {
                    childPermissions.forEach(childId => newSelected.delete(childId));
                }
            } else {
                newSelected.add(id);
                if (isParent) {
                    childPermissions.forEach(childId => newSelected.add(childId));
                }
            }

            if (!isParent) {
                const parentPermission = permissionsData.find(permission => 
                    permission.companiesRolePermission.some(companyPermission => companyPermission.companyPermission.id === id)
                );
                if (parentPermission) {
                    const allChildrenSelected = parentPermission.companiesRolePermission.every(companyPermission =>
                        newSelected.has(companyPermission.companyPermission.id)
                    );
                    if (allChildrenSelected) {
                        newSelected.add(parentPermission.parentPermission.id);
                    } else {
                        newSelected.delete(parentPermission.parentPermission.id);
                    }
                }
            }

            return newSelected;
        });
    };
    
    useEffect(() => {
        setSelectedPermissions(
            initial()
        )
    }, [permissionsData]);
    
    const handleCloseModal = () => {
        setIsOpen(false)
        setSelectedPermissions(new Set())
    }
    
    

    return (
                <FormDrawer display="center" size="2xl" isOpen={isOpen} setIsOpen={handleCloseModal}>
                    <div className="p-6">
                        <FormDrawer.Title
                            title={(title || 'Role') + " Permissions"}
                            showCloseButton={true}
                            close={handleCloseModal}
                        />
                        <hr className='mt-2' />
                        {rolePermissionLoading ?
                        <div className= "bg-white rounded-xl p-6 flex justify-center items-center" style={{height: '480px'}}>
                            <FontAwesomeIcon icon="circle-notch" spin />
                        </div>
                        :
                            <div>
                            {permissionsData?.map(permission => (
                                <div key={permission.id} className="role-section mb-6">
                                    <div className="flex my-6 bg-ep-gray-100 py-6 px-2 rounded-lg">
                                        <label className='inline-flex items-center'>
                                            {/* <input
                                                type="checkbox"
                                                checked={selectedPermissions.has(permission.parentPermission.id)}
                                                onChange={() => handleCheckboxChange(
                                                    permission.parentPermission.id,
                                                    true,
                                                    permission.companiesRolePermission.map(companyPermission => companyPermission.companyPermission.id)
                                                )}
                                                className={`form-checkbox w-5 h-5 multi-select-header mr-3 ${permission.disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                                                disabled
                                            /> */}
                                            <div className="flex items-center">
                                                <h3 className='text-black font-bold'>{permission.parentPermission.name}</h3>
                                                <span className="mx-1">-</span>
                                                <p className='text-ep-gray-600 font-medium'>{' '}{permission.parentPermission.description}</p>
                                            </div>
                                        </label>
                                    </div>
                                    <div className="">
                                        {permission?.companiesRolePermission?.map(companyPermission => (
                                            <div key={companyPermission.id} className="permission-item mb-4">
                                                <label className='inline-flex items-center px-2'>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedPermissions.has(companyPermission.companyPermission.id)}
                                                        onChange={() => handleCheckboxChange(companyPermission.companyPermission.id)}
                                                        className={`form-checkbox w-5 h-5 multi-select-header mr-3`}
                                                        disabled
                                                    />
                                                    <span className="font-normal text-ep-gray-300">
                                                        {companyPermission.companyPermission.description}
                                                    </span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                        }
                        <div className="p-1 mt-4 flex justify-end">
                            <div className='flex'>
                                <div>
                                    <button type="button" onClick={handleCloseModal} className="btn btn-lg w-full rounded-lg whitespace-nowrap border border-ep-primary-600 text-white bg-ep-primary-600">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </FormDrawer>
    );
};

export default ViewRoleModal;
